module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dropzone-box"
  }, [_c('input', {
    staticClass: "dropzone-input-file",
    attrs: {
      "type": "file",
      "name": _vm.uploadFieldName,
      "accept": "image/*"
    },
    on: {
      "change": _vm.fileChange
    }
  }), _vm._v(" "), (_vm.isInitial) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.placeholder)
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a6d11f4a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DropZone.vue
// module id = 1047
// module chunks = 1